import React, { Component } from 'react';
import OrderStore from '../store/OrderStore';

const orderDb = new OrderStore('orderDb');

export const withOrder = (WrappedComponent) => class WithOrder extends Component {
    state = {
      orders: [],
    };

    load = () => {
      orderDb.getOrders((orders) => {
        if (!orders) {
          return;
        }

        this.setState({ orders });
      });
    };

    createOrder = (order) => {
      orderDb.createOrder(order, this.load);
    };

    addMultipleOrder = (orders) => {
      orderDb.createMultipleOrder(orders, this.load);
    };

    closeOrder = (id, order) => {
      orderDb.closeOrder(id, { ...order }, this.load);
    };

    closeOrderButFailedToSync = (id, order) => {
      orderDb.closeOrderButFailedToSync(id, { ...order }, this.load);
    };

    updateOrder = (id, order) => {
      orderDb.updateOrder(id, { id, ...order }, this.load);
    };

    onAddOrUpdateOrderProduct = ({ order, product, onSuccess }) => {
      const handleSuccess = () => {
        this.load();
        onSuccess();
      };

      orderDb.onAddOrUpdateOrderProduct({
        order,
        product,
        onSuccess: handleSuccess,
      });
    };

    onAddMultipleProductsToOrder = ({ order, products, onSuccess }) => {
      const handleSuccess = () => {
        this.load();
        onSuccess();
      };

      orderDb.onAddMultipleProductsToOrder({
        order,
        products,
        onSuccess: handleSuccess,
      });
    };

    removeProductFromOrder = ({ order, id, onSuccess = () => {} }) => {
      const handleSuccess = () => {
        this.load();
        onSuccess();
      };

      orderDb.removeProductFromOrder({
        order,
        id,
        onSuccess: handleSuccess,
      });
    };

    remove = (key) => {
      orderDb.remove(key, this.load);
    };

    render() {
      return (
        <WrappedComponent
          orders={{
            value: this.state.orders,
            addMultipleOrder: this.addMultipleOrder,
            closeOrder: this.closeOrder,
            closeOrderButFailedToSync: this.closeOrderButFailedToSync,
            createOrder: this.createOrder,
            onAddOrUpdateOrderProduct: this.onAddOrUpdateOrderProduct,
            onAddMultipleProductsToOrder: this.onAddMultipleProductsToOrder,
            updateOrder: this.updateOrder,
            removeProductFromOrder: this.removeProductFromOrder,
            remove: this.remove,
            load: this.load,
          }}
          {...this.props}
        />
      );
    }
};

export default withOrder;
